import React from "react";
import { DefaultText } from "theme/GlobalElements";
import { IoIosGitCompare } from "react-icons/io";
import { headerButtonStyles } from "./styled";
import styled from "styled-components/macro";
import { useNavigate } from "react-router-dom";
import { Counter } from "features/cart/DesktopCartButton";
import CartDropdownData from "features/cart/CartDropdownData";
import { bgFade } from "theme/Animations";
import { toRem } from "theme/Breakpoints";
import userStorage from "store/UserStorage";
import { selectProductsToCompareUpdate, update } from "features/compare/compareSlice";
import { useDispatch, useSelector } from "react-redux";

const CompareButton = () => {
  const navigate = useNavigate();
  const productsToCompare = userStorage.getStoredForCompare();
  const checkForUpdate = useSelector(selectProductsToCompareUpdate);
const dispatch = useDispatch()
  const onClick = () => {
    navigate("/compare");
  };

  const removeElementWithId = (id: string) => {
    dispatch(update(true));
    userStorage.removeItemForCompare(id);
    dispatch(update(false));
  };
  return (
    <Container>
      <HeaderButton onClick={onClick}>
        <IoIosGitCompare color="white" size="1.5em" />
        <DefaultText fontSize={16} color="white">
          Сравни
        </DefaultText>
      </HeaderButton>
      <DropdownDataContainer>
        <DataWrapper>
          <CartDropdownData
            showCount={false}
            emptyMessage="Няма продукти добавени за сравняване"
            actionButtonTitle="Сравни"
            actionRoute="/compare"
            listedItems={productsToCompare.map((product: any) => {
              return { product };
            })}
            removeElementWithId={removeElementWithId}
          />
        </DataWrapper>
      </DropdownDataContainer>
      <Counter></Counter>
      <Counter>
        <DefaultText color={"white"}>{productsToCompare.length}</DefaultText>
      </Counter>
    </Container>
  );
};
const Container = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;
const HeaderButton = styled.div`
  ${headerButtonStyles}
`;

export const DropdownDataContainer = styled.div`
  position: absolute;
  min-width: 160px;
  right: 0;
  z-index: 10;
  display: none;

  ${Container}:hover & {
    animation: ${bgFade} 0.3s ease-out;
    display: block;
  }
`;

export const DataWrapper = styled.div`
  width: ${toRem(400)};
  margin-top: 12px;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

  &::before {
    content: "";
    border-style: solid;
    border-width: 10px 10px 10px 20px;
    border-color: transparent #fff transparent transparent;
    position: absolute;
    transform: rotate(90deg);
    top: -10px;
    right: 10px;
  }
`;

export default CompareButton;
